<app-canvas></app-canvas>
<app-chat *ngIf="isMobile==false"></app-chat>
<app-dicemacro></app-dicemacro>
<app-control></app-control>
<app-token></app-token>